import type { SortedProvidersIdsToOrder } from '@bcf-vanilla-ts-v1-configurators/tokens/slots/types';
import { DiToken } from '@bcf-vanilla-ts-v1-shared/di/di-token';

// biome-ignore lint/style/useNamingConvention: token
export const SORTED_PROVIDERS_IDS_TO_ORDER: DiToken<SortedProvidersIdsToOrder> = new DiToken<SortedProvidersIdsToOrder>(
  'sortedProvidersIdsToOrder',
  { factory: () => [] }
);
